module.exports = __webpack_public_path__ + "media/images/logo_toto-fef9913c38dc6c4b274e54468ee30f5e.jpg";